import axios from 'axios';
import { axiosInstance } from '../clients/axiosClient';
import { API_V1_PREFIX } from '../utils/constants';
import { PreScanMemberProfile } from '../types/preScanTypes';

const getTokenFromQuery = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  if (token && token.length > 0) {
    return token;
  }

  const storedToken = sessionStorage.getItem('temp_token');
  if (storedToken) {
    const newUrl = `${window.location.pathname}?token=${storedToken}`;
    window.history.replaceState({}, '', newUrl);
    return storedToken;
  }

  return null;
};

const preScanAxiosInstance = axios.create({
  baseURL: axiosInstance.defaults.baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

preScanAxiosInstance.interceptors.request.use((config) => {
  const token = getTokenFromQuery();
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const validatePreScanToken = async (token: string): Promise<any> => {
  try {
    const { data } = await preScanAxiosInstance.post(
      `${API_V1_PREFIX}members/validate-token`,
      { token }
    );
    return data;
  } catch (error: any) {
    if (error.response?.data?.detail) {
      throw error.response.data;
    }
    throw error;
  }
};

export const getPreScanMemberProfile = async (): Promise<PreScanMemberProfile> => {
  try {
    const { data } = await preScanAxiosInstance.get(`${API_V1_PREFIX}members/`, {
      params: { load_strategy: 'with_subscription' },
    });
    return data;
  } catch (error: any) {
    if (error.response?.data?.detail) {
      throw error.response.data;
    }
    throw error;
  }
};

export const submitPreScanQuestionnaire = async (
  token: string,
  questionnaire: Record<string, string | boolean | Record<string, boolean>>
): Promise<{ status: string }> => {
  try {
    const { data } = await preScanAxiosInstance.post(
      `${API_V1_PREFIX}members/pre-scan-questionnaire`,
      { token, questionnaire }
    );
    return data;
  } catch (error: any) {
    if (error.response?.data?.detail) {
      throw error.response.data;
    }
    throw error;
  }
};
